export default __webpack_public_path__ + "static/media/element_36.e8d54503.jpg";